import MyNotificationsLayout from "./MyNotificationsLayout";

export default MyNotificationsLayout;
